import styled from 'styled-components';
import { breakSmall, breakMedium } from '../themes/homedepotcom/breakpoints';

export default styled.div`
  .config-total-price, .config-original-price {
    font-size: 36px;
    font-weight: bold;
    margin: 0.25em 0;
  }

  .dollar-sign{
    font-size: 0.6em;
    display: inline-block;
    position: relative;
    top: -9px;
  }
  @media only screen and (max-width: ${breakSmall}) {
    .dollar-sign{
      font-size: 0.8em;
      top: -3px;
    }
  }

  .cents {
    vertical-align: super;
    font-size: 0.5em;
  }

  .config-price-container {
    display: flex;
    align-items: center;
    .special-buy {
      height: 40px;
    }
    @media only screen and (max-width: ${breakSmall}) {
      .special-buy {
        height: 30px;
      }
    }

    .config-price-box {
      display: flex;
      margin-left: 10px;


      .config-total-price {
        font-size: 0.8em;
        display: flex;
        flex-direction: column;
      }

      .config-was-price {
        text-decoration: line-through;
        margin-bottom: 5px;
      }
      .config-was-price-price::before {
        content: ' ';
      }
      .config-total-price-promo {
        font-size: 36px;
        font-weight: 600;
        margin-right: 10px;
        align-self: center;
      }

      .config-saved-text {
        color: #00873C;
        font-weight: 400;
      }
    }
  }

  .config-original-price {
    margin: -0.25em 0;
    height: 75px;
  }
  @media only screen and (max-width: ${breakMedium}) {
    .config-original-price {
      margin: inherit;
    }
  }

  .config-total-price {
    font-size: 18px;
    font-weight: normal;
  }
`;
